import { render, staticRenderFns } from "./organigram.vue.html?vue&type=template&id=61cdb776"
import script from "./organigram.controller?vue&type=script&lang=js&external"
export * from "./organigram.controller?vue&type=script&lang=js&external"
import style0 from "./organigram.vue.html?vue&type=style&index=0&id=61cdb776&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports